export type ActivePassiveFilter = "" | "true" | "false";

export const DEFAULT_ACTIVE_PASSIVE_FILTER: ActivePassiveFilter = "true";

export function activePassiveToOptionalBoolean(
  value: ActivePassiveFilter,
): boolean | undefined {
  if (value === "true") return true;
  if (value === "false") return false;
  return undefined;
}

export function activePassiveToTriState(value: ActivePassiveFilter): boolean | "" {
  if (value === "") return "";
  return value === "true";
}

type Props = {
  value: ActivePassiveFilter;
  onChange: (value: ActivePassiveFilter) => void;
  className?: string;
  disabled?: boolean;
  allLabel?: string;
};

export function ActivePassiveFilterSelect({
  value,
  onChange,
  className = "kp-input",
  disabled,
  allLabel = "Tüm durumlar",
}: Props) {
  return (
    <select
      className={className}
      value={value}
      disabled={disabled}
      aria-label="Durum filtresi"
      onChange={(e) => onChange(e.target.value as ActivePassiveFilter)}
    >
      <option value="">{allLabel}</option>
      <option value="true">Aktif</option>
      <option value="false">Pasif</option>
    </select>
  );
}
